import { render, staticRenderFns } from "./addHcbo.vue?vue&type=template&id=1a8e09d9"
import script from "./addHcbo.vue?vue&type=script&lang=js"
export * from "./addHcbo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports